import Vue from 'vue';
import Vuex from 'vuex';
import LoginSever from '@/common/api-config/LoginSever';
import authorizedBase from '@/common/authorized-config';
Vue.use(Vuex);
const store ={
  state:{ //状态对象：共享值的集合
    "id": '',//ID
    "realName": "",//实际名
    "account": "",//用户名
    "roleName": "",//角色名
    "permissionList":[],//权限数据
  },
  mutations:{  //同步修改
    set(state, obj){//初始化
      for(let name in obj){
        state[name] = obj[name];
      }
    },
  },
  getters:{//监测状态
    userInfo:(state)=>{
      return state
    },
  },
  actions:{//异步修改
    updateUser(context,obj){ //context 上下文对象，同管全局
      return new Promise((resolve, reject)=>{
        LoginSever.currentUser().then((res)=>{
          if(res.code==0 ){
            res.data.permissionList = utils.getArrFromObj(authorizedBase,res.data.permissionList);//通过key与权限基本数据里对应的key对比，提炼出许可的路由地址
            context.commit('set',res.data); //上下文对象调用commit执行add方法
            resolve()
          }else{
            this.$message.error('登录失败');
            reject()
          }
        })
      })
    },
  }
}

export default store

